import { useRef } from 'react';

// material-ui
import { Box } from '@mui/material';

// project import
import IconButton from 'components/@extended/IconButton';

// assets
import settingsIcon from 'assets/images/icons/header/settings.svg';
import { useNavigate } from 'react-router';

// ==============================|| HEADER CONTENT - SETTINGS ||============================== //

const Settings = () => {
  const anchorRef = useRef<any>(null);
  const navigate = useNavigate();

  return (
    <Box sx={{ flexShrink: 0, ml: 0.5 }}>
      <IconButton
        color="secondary"
        sx={{ color: 'text.primary', bgcolor: 'transparent', '&:hover': { bgcolor: 'transparent' } }}
        aria-label="settings"
        ref={anchorRef}
        onClick={() => navigate('/account-settings')}
      >
        <img src={settingsIcon} alt="settings" style={{ width: 18, height: 18 }} />
      </IconButton>
    </Box>
  );
};

export default Settings;
